import round from 'lodash/round.js';

/** Convert the given date into a Blizzard timestamp (float precision seconds). */
export function dateToBlizzardTimestamp(date: Date): number {
  return date.getTime() / 1000;
}

/** Convert the given Blizzard timestamp (float secs) back into (whole) milliseconds */
export function blizzardTimestampToMs(ts: number): number {
  return round(ts * 1000);
}
